import * as React from 'react'
import styled from 'styled-components'

import version from './../../../version'

import Common, { TwoRows } from './Common'

const HeroBg = require('./grph_element_5.svg')

const AboutWrapper = styled.div`
  background: url(${HeroBg}) left / 300px no-repeat #00b0b9;
`

const AboutRow = styled.div`
  color: ${({ theme }) => theme.colors.invert};
  padding: 10px;
  width: 50%;

  display: flex;
  flex: 1 0 0%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 450px;

  h2 {
    font-size: 45px;
    font-weight: bold;
    text-align: center;
  }

  p {
    width: 100%;
    font-size: 21px;
    letter-spacing: 0.5px;
    word-wrap: break-word;
  }

  p + p {
    margin-top: 15px;
  }
`

const About = () => (
  <Common>
    <h2 className="feature-title">
      About Peikko Designer&reg; DELTABEAM SELECT
    </h2>
    <AboutWrapper>
      <TwoRows>
        <AboutRow>
          <h2>
            A faster, safer,<br />and more efficient way<br />to design and
            build
          </h2>
        </AboutRow>
        <AboutRow>
          <p>
            Peikko Designer® DELTABEAM SELECT is a free preselection tool
            designed for selecting suitable DELTABEAM® types for your project.
            Calculation is based on basic Eurocode design taking account both
            ultimate and serviceability limit state. Some special designs are
            excluded (e.g. accidental design, frequency, flexible shear and
            effect of torsional moments). The calculation of forces, moments and
            deformations of the beam structure is based on FEM (Finite Element
            Method).
          </p>
          <p>
            Peikko always makes the final design for DELTABEAMs based on exact
            information from the project. The results of this preselection tool
            cannot be used as information to tender as they are – please check
            needed documentation for tenders from local Peikko offices.
          </p>
          <p>
            Peikko Designer® DELTABEAM SELECT<br />
            Version: {version}
          </p>
        </AboutRow>
      </TwoRows>
    </AboutWrapper>
  </Common>
)

export default About



// WEBPACK FOOTER //
// ./src/Components/Layout/Features/About.tsx